import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import director from "../../assets/a1.jpeg";
import bgImage from "../../assets/bgs.png";
export default function DirectorSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-120px" });

  return (

      <section
  ref={ref}
  className="relative py-24 md:py-32 overflow-hidden"
>

{/* BACKGROUND IMAGE */}
<div className="absolute inset-0">
  <img
    src={bgImage}
    alt=""
    className="w-full h-full object-cover"
  />

  {/* Dark overlay for readability */}
  <div className="absolute inset-0 bg-white/40" />

</div>

   
      <div className="relative z-10 max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16 items-center">



        

        {/* CONTENT — Wave Reveal */}
        <motion.div
         className="order-2 lg:order-1"
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={{
            hidden: {},
            visible: {
              transition: { staggerChildren: 0.12 },
            },
          }}
        >
          {/* Badge */}
          <motion.span
            variants={{
              hidden: { opacity: 0, x: 30 },
              visible: { opacity: 1, x: 0 },
            }}
            className="inline-block text-[#064BA5] text-sm font-semibold tracking-wide mb-3"
          >
            Leadership Message
          </motion.span>

          {/* Heading */}
          <motion.h2
            variants={{
              hidden: { opacity: 0, clipPath: "inset(0 100% 0 0)" },
              visible: { opacity: 1, clipPath: "inset(0 0% 0 0)" },
            }}
            transition={{ duration: 1.5 }}
            className="text-[30px] sm:text-[36px] md:text-[40px] font-serif text-gray-900 leading-[1.2]"
          >
            Guiding Students Toward a  
            <span className="text-[#064BA5] font-semibold"> Global Future</span>
          </motion.h2>

          {/* Paragraph */}
          <motion.p
            variants={{
              hidden: { opacity: 0, clipPath: "inset(0 100% 0 0)" },
              visible: { opacity: 1, clipPath: "inset(0 0% 0 0)" },
            }}
            transition={{ duration: 1.5 }}
            className="mt-4 text-gray-600 leading-[1.8] text-[15px]"
          >
            At Goodwill Global Solutions, we believe every student deserves transparent guidance, ethical admissions, and a trusted international education pathway.
          </motion.p>

          <motion.p
            variants={{
              hidden: { opacity: 0, clipPath: "inset(0 100% 0 0)" },
              visible: { opacity: 1, clipPath: "inset(0 0% 0 0)" },
            }}
            transition={{ duration: 1.5 }}
            className="mt-4 text-gray-600 leading-[1.8] text-[15px]"
          >
            Our leadership is committed to delivering long-term career success through globally recognized universities and personalized counseling strategies.
          </motion.p>

          {/* Director Name — Signature Reveal */}
          <motion.div
            variants={{
              hidden: { opacity: 0, clipPath: "inset(0 100% 0 0)" },
              visible: { opacity: 1, clipPath: "inset(0 0% 0 0)" },
            }}
            transition={{ duration: 1.5 }}
            className="mt-7"
          >
            <p className="font-bold text-gray-900 text-[17px]">
              Mr. PYDI KARTHIK
            </p>

            <motion.div
              initial={{ width: 0 }}
              animate={isInView ? { width: 120 } : {}}
              transition={{ duration: 1.5, ease: "easeOut" }}
              className="h-[2px] bg-[#064BA5] mt-1 rounded"
            />

            <p className="text-gray-500 font-semibold text-[14px] mt-1">
               Director — Goodwill Global Solutions
            </p>
          </motion.div>
        </motion.div>
{/* IMAGE — Parallax Executive Reveal */}
        <motion.div
          initial={{ opacity: 0, x: -120, scale: 0.9 }}
          animate={isInView ? { opacity: 1, x: 0, scale: 1 } : {}}
          transition={{ duration: 2, ease: [0.16, 1, 0.3, 1] }}
           className="relative flex justify-center order-1 lg:order-2"

        >
          {/* Luxury Glow */}
          <motion.div
            animate={{ opacity: [0.15, 0.35, 0.15] }}
            transition={{ duration: 4, repeat: Infinity }}
            className="absolute -inset-6 rounded-full blur-3xl bg-blue-300/40"
          />

          <img
            src={director}
            alt="Managing Director - Goodwill Global Solutions"
            className="relative w-full max-w-[420px] h-[220px] sm:h-[380px] md:h-[420px] lg:h-[520px] xl:h-[600px] rounded-3xl shadow-2xl object-cover"

          />
        </motion.div>
      </div>
    </section>
  );
}
